module.exports = __webpack_public_path__ + "c21af532d471289fc190e1b15c822871.svg";